export default __webpack_public_path__ + "static/media/Columns.c3500fe4.svg";